import { Quark, HttpGet, Url, HttpResponse, HttpPost, HttpPut, JSONData } from 'sol-request-angular/dist/comunicacao';
import { Injectable } from '@angular/core';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { Bairro, Cidade } from "@tivic-team/manager-ts/dist/grl";
import { CidadeDTO } from 'app/dtos/grl/cidade.dto';
import { environment } from 'environments/environment';

@Injectable()
export class CidadeController{
    
    constructor() { }
	
    async find(filtros?:IFilter):Promise<Array<Cidade>>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/cidades',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Cidade>()
			)
		);
		return await quark.call();
	}

	async get(cdCidade:number):Promise<CidadeDTO>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/cidades/:cdCidade',
					environment: environment,
					pathParams: new JSONData({cdCidade: cdCidade})
				}),
			}),
			new HttpResponse(
				new CidadeDTO()
			)
        );
        
        return await quark.call();
	}

	async create(cidade: Cidade):Promise<Cidade>{
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/cidades',
					environment: environment
				}),
				data: new JSONData(cidade)
			}),
			new HttpResponse(
				new Cidade()
			)
		);

		return await quark.call();
	}

	async update(cidade: Cidade):Promise<Cidade>{
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'grl/cidades/:cdCidade', 
					environment: environment, 
					pathParams: new JSONData({cdCidade: cidade.cdCidade})
				}),
				data: new JSONData(cidade)
			}),
			new HttpResponse(
				new Cidade()
			)
		);
		return await quark.call();
	}

	async getBairros(cdCidade:number):Promise<Bairro[]>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/cidades/:cdCidade/bairros',
					environment: environment,
					pathParams: new JSONData({cdCidade: cdCidade})
				}),
			}),
			new HttpResponse(
				new Array<Bairro>()
			)
        );
        
        return await quark.call();
	}
	
}